import Api from "@/assets/api/index";
import router from "@/router/index";
import store from "@/store/index";
import { asyncRouterMap, constantRouterMap } from "@/router/index";
import { resetRouter } from "@/router/index";
import { deepClone } from "@/utils/deepClone";

const state = {
  menuList: [],
  routes: [],
  addRoutes: [],
};
const mutations = {
  SET_MENU_LIST(state, val) {
    state.menuList = val;
  },
  SET_ROUTES(state, val) {
    state.addRoutes = val;
    state.routes = state.routes = constantRouterMap.concat(val);
  },
  CLEAR_PERMISSION(state) {
    state.menuList = [];
    state.routes = [];
    state.addRoutes = [];
  },
};
const actions = {
  //获取用户的菜单权限
  setMenuList({ commit }) {
    return new Promise((resolve, reject) => {
      Api.selectRoleByUserId({
        userId: store.state.user.userInfo.id,
        projectId: store.state.user.currentProject.id,
      }).then((res) => {
        if (res.code === 0) {
          const menuList = [];
          getMenuList(res.data, menuList);
          commit("SET_MENU_LIST", menuList);
          resolve(menuList);
        } else {
          reject();
        }
      });
    });
  },
  //更改权限
  async changeRoles({ dispatch, state }, route) {
    const originMenu = state.menuList;
    const menuList = await dispatch("setMenuList");
    //当前用户权限被修改时重置菜单
    if (JSON.stringify(originMenu) !== JSON.stringify(menuList)) {
      resetRouter();
      const accessRoutes = await dispatch("generateRoutes", menuList);
      accessRoutes.forEach((r) => {
        router.addRoute(r);
      });
      let historyRoutes = updateHistoryRoute();
      if (historyRoutes.length > 0) {
        //有历史路由
        let flag = historyRoutes.some((item) => {
          return item.path === route.path;
        });
        if (!flag) {
          //当前页不在历史路由中跳转第一个历史路由
          router.push(historyRoutes[0].path);
        }
      } else {
        //无历史路由
        if (menuList.length === 0) {
          //权限为空前往404
          router.push("/404");
        } else if (accessRoutes[0] && accessRoutes[0].path) {
          //权限不为空前往第一个菜单路由
          accessRoutes[0].children &&
            router.push(accessRoutes[0].children[0].path);
        }
      }
    }
  },
  //生成路由
  generateRoutes({ commit }, menuList) {
    return new Promise((resolve) => {
      const accessedRouters = deepClone(asyncRouterMap).filter((route) => {
        let tempMenu = hasPermission(route, menuList); //一级菜单是否有权限，如果有就返回该菜单
        if (tempMenu) {
          if (
            route.children &&
            route.children.length > 0 &&
            tempMenu.children &&
            tempMenu.children.length > 0
          ) {
            //如果有二级路由
            route.children = route.children.filter((child) => {
              if (hasPermission(child, tempMenu.children)) {
                //判断二级路由是否有权限
                return child;
              } else {
                return false;
              }
            });
            return route;
          } else {
            return route;
          }
        } else {
          return false;
        }
      });
      // addCombinedRoutes(accessedRouters);
      commit("SET_ROUTES", accessedRouters);
      resolve(accessedRouters);
    });
  },

  // // 处理当前路径
  // updateCurrentPath(context, val) {
  //   routerUtils.setCurrentPath();
  // },
};
function hasPermission(route, menuList) {
  if (route.meta && route.meta.title) {
    return menuList.find((ele) => {
      return (
        ele.title === route.meta.title ||
        ele.title === route.meta.relatedPermission
      );
    });
  } else {
    return undefined;
  }
}

function getMenuList(data, menuList) {
  data.forEach((ele) => {
    let tempArr = {};
    if (ele.checked) {
      menuList.push(tempArr);
      tempArr.title = ele.permissionName;
      if (ele.childList && ele.childList.length > 0) {
        tempArr.children = [];
        getMenuList(ele.childList, tempArr.children);
      }
    }
  });
}
// 历史路由过滤
function updateHistoryRoute() {
  const tempMenu = state.menuList;
  console.log("tempMenu", tempMenu);
  let historyRoutes = store.state.common.historyRouter;
  console.log("formerRoute", historyRoutes);
  historyRoutes = historyRoutes.filter((ele) => {
    if (ele.meta && ele.meta.title) {
      let flag = hasHistory(tempMenu, ele);
      return flag;
    } else {
      return false;
    }
  });
  console.log("historyRoutes", historyRoutes);
  store.commit("common/SET_HISTORY_ROUTER", historyRoutes);
  return historyRoutes;
}

function hasHistory(menu, historyRoute) {
  return menu.some((ele) => {
    if (ele.title === historyRoute.meta.title) {
      return true;
    } else {
      if (ele.children && ele.children.length > 0) {
        return hasHistory(ele.children, historyRoute);
      } else {
        return false;
      }
    }
  });
}

// function addCombinedRoutes(accessedRouters) {
//   combinedroutes.forEach((ele) => {
//     let parentRoute = accessedRouters.find((item) => {
//       return item.meta && item.meta.title === ele.parentTitle;
//     });
//     if (parentRoute.children && parentRoute.children.length > 0) {
//       let isExist = parentRoute.children.some((item) => {
//         return item.meta.title === ele.title;
//       });
//       if (!isExist) {
//         let isCombined = parentRoute.children.some((item) => {
//           return item.meta.title === ele.combinedTitle;
//         });
//         if (isCombined) {
//           console.log(ele);
//           let res = findCombinedRoutes(deepClone(asyncRouterMap), ele);
//           console.log(res);
//           if (res) {
//             parentRoute.children.push(res);
//           }
//         }
//       }
//     }
//   });
// }

// function findCombinedRoutes(asyncRouterMap, combinedRoute) {
//   let parent = asyncRouterMap.find((ele) => {
//     return ele.meta && combinedRoute.parentTitle === ele.meta.title;
//   });
//   let res =
//     parent.children &&
//     parent.children.find((ele) => {
//       return ele.meta && ele.meta.title === combinedRoute.title;
//     });
//   return res;
// }

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
